import { BrideHistoryWarningReason } from '../api/MeetingsAPI';

export function brideHistoryWarningTranslationKey(
  reason?: BrideHistoryWarningReason | null
): string {
  switch (reason) {
    case 'MULTIPLE_ACTIVE_BOOKINGS':
      return 'booking.bride_history_warning.multiple';
    case 'PAST_CANCELLATIONS':
      return 'booking.bride_history_warning.past_cancellations';
    case 'BOTH':
      return 'booking.bride_history_warning.both';
    default:
      return 'booking.bride_history_warning.multiple';
  }
}

export function brideHistoryWarningTipTranslationKey(
  reason?: BrideHistoryWarningReason | null
): string {
  switch (reason) {
    case 'PAST_CANCELLATIONS':
    case 'BOTH':
      return 'booking.bride_history_warning.tip';
    case 'MULTIPLE_ACTIVE_BOOKINGS':
    default:
      return 'booking.bride_history_warning.tip.multiple';
  }
}
